import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";

const ColumnsList: ColumnsEdit = [
  {
    title: "Mã màu",
    dataIndex: "id",
    key: "id",
    show: true,
    align: "left",
    width: 80,
  },
  {
    title: "Tên màu",
    dataIndex: "name",
    key: "name",
    show: true,
    align: "left",
  },
  {
    title: "Mô tả",
    dataIndex: "description",
    key: "description",
    show: true,
    align: "left",
  },
  {
    title: "Ghi chú",
    dataIndex: "note",
    key: "note",
    show: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
    width: 80,
  },
];

export {ColumnsList};
